import PropTypes from "prop-types";
import React, { useCallback, useMemo, useState } from "react";
import cx from "classnames";
import styles from "./Tabs.module.scss";
import TabsHeader from "./TabsHeader";
import TabsContent from "./TabsContent";
import TabsCell from "./TabsCell";
import withTheme from "../../libs/themr/withTheme";

const Tabs = ({ theme, defaultTabId, tabId, onChange, className, children, renderActiveOnly }) => {
  const [selectedTabId, setTabId] = useState(defaultTabId);
  const currentId = useMemo(() => {
    if (tabId && onChange) {
      return tabId;
    }

    return selectedTabId;
  }, [selectedTabId, tabId, onChange]);

  const handleClick = useCallback(
    event => {
      const { id } = event.currentTarget;

      if (tabId && onChange) {
        onChange(id);
      } else {
        setTabId(id);
      }
    },
    [tabId, onChange]
  );
  const letRender = id => {
    if (!renderActiveOnly) {
      return true;
    }

    return id === currentId;
  };

  return (
    <div className={cx(theme.container, className)}>
      <TabsHeader theme={theme}>
        {React.Children.map(children, child => (
          <TabsCell theme={theme} {...child.props} selectedTabId={currentId} onClick={handleClick} />
        ))}
      </TabsHeader>
      {React.Children.map(
        children,
        child =>
          letRender(child.props.id) && (
            <TabsContent theme={theme} visible={child.props.id === currentId}>
              {React.Children.toArray(child.props.children)}
            </TabsContent>
          )
      )}
    </div>
  );
};

Tabs.propTypes = {
  defaultTabId: PropTypes.string,
  tabId: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  renderActiveOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired
};

Tabs.defaultProps = {
  defaultTabId: null,
  tabId: null,
  onChange: null,
  renderActiveOnly: true,
  className: null
};

export default withTheme(styles)(Tabs);
